import React, {useEffect, useState} from 'react';
import {Paper, Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';
import AutomGallery from './gallery/AutomGallery';
import BotCard from './botCard/BotCard';
import BotService from '../../../../services/BotService/BotService';
import {useParams} from "react-router-dom";
import {useSetRecoilState} from 'recoil';
import {alertState} from '../../../../recoil-store/recoil-state';
import './AutomDetails.css';

const useStyles = makeStyles(theme => ({
    root: {flexGrow: 1},
    descGrid: {padding: '10px 20px', width: '100%'}
}));

const AutomDetails = (props) => {
    const {t} = useTranslation();
    const classes = useStyles();
    const params = useParams();
    const paramsId = params.id;
    const [data, setData] = useState({});
    const setAlert = useSetRecoilState(alertState);

    useEffect(() => {
        fetchData().then(r => r);
    }, []);
    const fetchData = async () => {

        const response = await BotService.getBotDetails(paramsId);
        if (response) {
            if (response.status) {
                setData(response.data);
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t(`CONTENT.BOT-DETAILS.${response.message}`),
                    severity: response.status ? 'success' : 'error'
                }))
            }
        } else {
            setAlert(alert => ({...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error'}))
        }
    };
    return (
        <Paper className={classes.root} data-test="autom-details" elevation={3}>
            <header className="automdetail-header">{data?.name}&nbsp;</header>
            <Grid container>
                <Grid item md={8} className={classes.descGrid}>
                    <p>{data?.bot_details?.short_description}</p>
                    <div className="benefits-container">
                        <div className="benefits">{t('CONTENT.BOT-DETAILS.BENEFIT')}</div>
                        <div className="divider"/>
                        <div>{data?.bot_details?.benefits}</div>
                    </div>
                    <hr/>
                    <div>
                        <h4>{t('CONTENT.BOT-DETAILS.DESCRIPTION')}</h4>
                        <p>{data?.description}</p>
                    </div>
                    <hr/>
                    <div className="detail-setup">
                        <h4>{t('CONTENT.BOT-DETAILS.SET-UP')}</h4>
                        <ol>
                            <li>&nbsp;</li>
                            <li>&nbsp;</li>
                            <li>&nbsp;</li>
                        </ol>
                    </div>
                    <hr/>
                    <div className={classes.root}>
                        <h4>{t('CONTENT.BOT-DETAILS.GALLERY')}</h4>
                        <AutomGallery data={data}/>
                    </div>
                </Grid>
                <Grid item md={4} style={{margin: 'auto', width: '100%'}}>
                    <BotCard data={data}/>
                </Grid>
            </Grid>
        </Paper>
    );
};
export default AutomDetails;
